module.exports = __webpack_public_path__ + "static/Stefano_guglielmi_2-433594541b4e7e53f98b40edcc8256bf.jpg";